import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SelectItem } from "primeng/primeng";
import { BASE_CONSTANTS, BASE_URLS, TCITenantSelectorType, TCIToolDownloadType } from "@tci/common";
import { Subscription } from "rxjs";
import { NgToastrService } from "../../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import { ITCIEnvToolsAgentCreateMenuOutput } from "../../ng-tenant/tci-tenant-components";
import { BaseHybridAgentDownloadService } from "./base-hybrid-agent-download.service";
import { AbstractTCITenantComponent } from "../../ng-tenant/tci-tenant-component";
import { BaseEnvToolsAgentCreateMenuComponentInput, BaseEnvToolsAgentCreateMenuComponentOutput } from "../base-agent/base-agent-menu";

@Component({
    selector: TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_HYBRID.toString(),
    templateUrl: "./base-hybrid-agent-download.component.html",
    styleUrls: ["./base-hybrid-agent-download.component.less"]
})
export class BaseHybridAgentDownloadComponent<E, I extends BaseEnvToolsAgentCreateMenuComponentInput,
    O extends BaseEnvToolsAgentCreateMenuComponentOutput<ITCIEnvToolsAgentCreateMenuOutput>>
    extends AbstractTCITenantComponent<E, I, EventEmitter<ITCIEnvToolsAgentCreateMenuOutput>>
    implements OnInit, OnDestroy {

    @Output() output: EventEmitter<ITCIEnvToolsAgentCreateMenuOutput> = new EventEmitter();

    private subscriptions: Subscription[] = [];
    isPreparingDownload = false;
    loadingText = "Preparing download...";
    OSes: SelectItem[];
    selectedOS: SelectItem = null;
    hybridAgentVersion: { name: string, version: string, date: string } = null;
    dropdownStyles = {
        "background-color": "#4A99CE",
        "border": "none",
        "height": "50px",
        "line-height": "50px",
        "vertical-align": "middle",
        "width": "400px"
    };

    constructor(
        private translate: TranslateService,
        private toastr: NgToastrService,
        private baseHybridDownload: BaseHybridAgentDownloadService
    ) {
        super();
    }

    ngOnInit() {
        // TODO: Update ng-env-tools.lang.json for Hybrid agent info
        this.subscriptions.push(
            this.baseHybridDownload.getProductVersion()
            .subscribe(data => {
                this.hybridAgentVersion = data;
            }),
            this
            .translate
            .get([
                "NG_ENV_TOOLS.HYBRID_AGENT_DOWNLOAD_BUTTON_CAPTION.MAC_VERSION",
                "NG_ENV_TOOLS.HYBRID_AGENT_DOWNLOAD_BUTTON_CAPTION.WINDOWS_VERSION",
                "NG_ENV_TOOLS.HYBRID_AGENT_DOWNLOAD_BUTTON_CAPTION.LINUX_VERSION"
            ])
            .subscribe(
                data => {
                    this.OSes = [
                        {
                            label: data["NG_ENV_TOOLS.HYBRID_AGENT_DOWNLOAD_BUTTON_CAPTION.MAC_VERSION"],
                            value: "mac"
                        },
                        {
                            label: data["NG_ENV_TOOLS.HYBRID_AGENT_DOWNLOAD_BUTTON_CAPTION.WINDOWS_VERSION"],
                            value: "windows"
                        },
                        {
                            label: data["NG_ENV_TOOLS.HYBRID_AGENT_DOWNLOAD_BUTTON_CAPTION.LINUX_VERSION"],
                            value: "linux"
                        }
                    ];
                },
                error => {
                    console.log("Error getting translations for Hybrid agent OSes: ", error);
                }
            )
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    download() {
        if (this.selectedOS) {
            const url = `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.TOOLS}/${TCIToolDownloadType.hybridAgent}`;

            this.isPreparingDownload = true;
            this
                .subscriptions
                .push(
                    this
                        .baseHybridDownload
                        .download(url, this.selectedOS.toString(), "amd64")
                        .subscribe(
                            () => {
                                this.isPreparingDownload = false;
                            },
                            error => {
                                console.log(error);
                                this.toastr.error("Failed to download Hybrid agent tool.");
                            }
                        )
                );
        }
    }

    cancel() {
        this.closeModal(false);
    }

    protected closeModal(refresh: boolean): ITCIEnvToolsAgentCreateMenuOutput {
        const e: ITCIEnvToolsAgentCreateMenuOutput = {
            closeModal: true,
            refresh
        };
        this.output.emit(e);
        return e;
    }

    public formatDate(dateTimeString) {
        return new Date(dateTimeString.replace(/UTC/, "Z")).toLocaleDateString();
    }

}
